import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import './Search.css';

interface User {
  id: number;
  username: string;
  created_at: string;
  avatar_url?: string;
}

const Search: React.FC = () => {
  const [query, setQuery] = useState('');
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(false);

  const handleSearch = async (e: React.FormEvent) => {
    e.preventDefault();
    if (query.length < 2) return;

    setLoading(true);
    try {
      const response = await api.get(`/users/search?q=${encodeURIComponent(query)}`);
      setUsers(response.data.users);
    } catch (error) {
      console.error('Fehler bei der Suche:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="search">
      <h1>🔍 Benutzer suchen</h1>
      <form onSubmit={handleSearch} className="search-form">
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Benutzername eingeben..."
          className="search-input"
        />
        <button type="submit" disabled={loading || query.length < 2}>
          {loading ? 'Suche...' : 'Suchen'}
        </button>
      </form>

      {users.length > 0 && (
        <div className="search-results">
          <h2>Suchergebnisse</h2>
          <div className="users-list">
            {users.map((user) => (
              <Link key={user.id} to={`/profile/${user.id}`} className="user-card">
                <div className="user-info">
                  <h3>{user.username}</h3>
                  <p className="user-date">
                    Mitglied seit {new Date(user.created_at).toLocaleDateString('de-DE')}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}

      {query.length >= 2 && users.length === 0 && !loading && (
        <p className="no-results">Keine Benutzer gefunden.</p>
      )}
    </div>
  );
};

export default Search;

